<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCsvMaps(titleChart + ' as of ' + titleDateShow)" @zoomEnabled="zoomEnabled" @zoomDisabled="zoomDisabled" :zoomGraphValue="zoomGraphValue" :downloadId="downloadId" :specificSiteId="specificSiteId" :downloadShow="this.newCircleData && Object.keys(this.newCircleData).length > 0 && this.newSitesSelected.length > 0">
    <span slot="header">
      as of <span class="title-date">{{ titleDateShow }}</span>
    </span>
    <div class="col-xl-12 mb-0 pb-0 pl-0" slot="body">
      <div class="map-flex" v-if="this.newCircleData && Object.keys(this.newCircleData).length > 0 && this.newSitesSelected.length > 0">
        <div class="card-participant-map">
          <MapBase :config="config" :zoomValue="this.zoomValue">
            <template slot-scope="{ google, map }">
              <CircleMap :google="google" :map="map" :circleData="newCircleData" :mapZoom="map.getZoom()" :statusSelected="newStatusSelected" :countrySelected="newCountrySelected" :sitesSelected="newSitesSelected" />
            </template>
          </MapBase>
        </div>
        <div class="card-map-legend">
          <ul class="pl-20" :class="specificSiteId.length === 0 ? 'non-rbac' : 'rbac-legend'">
            <li v-on:click="onClick('ACTIVE')">
              <span v-bind:class="[this.newStatusSelected.indexOf('ACTIVE') > -1 ? '' : selectedClass]">
                <span class="active-status"></span>
                Active
              </span>
            </li>
            <li v-on:click="onClick('ACTIVEWMODIFICATION')">
              <span v-bind:class="[this.newStatusSelected.indexOf('ACTIVEWMODIFICATION') > -1 ? '' : selectedClass]">
                <span class="invited-status"></span>
                Active with Modifications
              </span>
            </li>
            <li v-if="legacyVal" v-on:click="onClick('DISQUALIFIED')">
              <span v-bind:class="[this.newStatusSelected.indexOf('DISQUALIFIED') > -1 ? '' : selectedClass]">
                <span class="disqualified-status"></span>
                Disqualified
              </span>
            </li>
            <li v-if="legacyVal" v-on:click="onClick('WITHDRAWSTUDY')">
              <span v-bind:class="[this.newStatusSelected.indexOf('WITHDRAWSTUDY') > -1 ? '' : selectedClass]">
                <span class="withdrawStudy-status"></span>
                Withdrawn
              </span>
            </li>
            <li v-if="!legacyVal" v-on:click="onClick('DISCONTINUED')">
              <span v-bind:class="[this.newStatusSelected.indexOf('DISCONTINUED') > -1 ? '' : selectedClass]">
                <span class="disqualified-status"></span>
                Discontinued
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="align-center p-60" slot="body">
        <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
      </div>
      <div class="remove-elem-download text-left min-height-0 pl-0 pb-0" style="bottom: auto;margin-top: 10px;" v-if="this.newCircleData && Object.keys(this.newCircleData).length > 0 && this.newSitesSelected.length > 0">
        <img v-on:click="onZoomOut" src="/static/img/icon-zoomout.svg" width="25" aria-haspopup="true" aria-expanded="false" title="Zoom Out" style="cursor: pointer;" />
        <img v-on:click="onZoomIn" src="/static/img/icon-zoomin.svg" width="25" aria-haspopup="true" aria-expanded="false" title="Zoom In" style="cursor: pointer;" />
      </div>
    </div>
  </chart-container>
</template>

<script>
import moment from "moment";
import MapBase from "../maps/map-base";
import CircleMap from "../maps/templates-map/circle-map";
import { mapSettings } from "../maps/config";
import ChartContainer from "./chart-container.vue";
import { downloadCSV } from "../../services/visualization/data-management";
import * as se from "@/services/visualization/study-executive";
import _ from "lodash";

export default {
  components: {
    MapBase,
    CircleMap,
    ChartContainer
  },
  props: {
    titleChart: [String],
    titleDate: { default: "" },
    rawData: { default: null },
    specificSiteId: { type: Array, default: () => {} },
    sitesSelected: [Array, String],
    countrySelected: [Array, String],
    countryList: { type: Array, default: () => [] },
    allSiteList: { type: Array, default: () => [] },
    dataLoaded: { type: Boolean, default: false },
    zoomGraphValue: { type: String, default: "" }
  },
  data() {
    return {
      downloadId: "studyMaps",
      newCircleData: null,
      titleDateShow: "",
      newStatusSelected: ["ACTIVE", "DISQUALIFIED", "ACTIVEWMODIFICATION", "WITHDRAWSTUDY"],
      legacyVal: true,
      newCountrySelected: this.countrySelected,
      newSitesSelected: this.sitesSelected,
      selectedClass: "selected",
      zoomValue: 5,
      downloadDataMaps: [],
      studyId: this.$route.params.studyId
    };
  },
  watch: {
    rawData: function(value) {
      this.newCircleData = se.getDataForCircleMarker(value, this.countryList, this.allSiteList);
      this.downloadDataMaps = se.generateMapParticipantSeries(this.newCircleData);
    },
    statusSelected: function(value) {
      this.newStatusSelected = value;
    },
    zoomValue: function(value) {
      this.zoomValue = value;
    },
    titleDate: function(newValue) {
      this.titleDateShow = moment(newValue)
        .format("DD MMM YYYY")
        .toUpperCase();
    },
    countrySelected: function(newValue) {
      this.newCountrySelected = newValue;
    },
    sitesSelected: function(newValue) {
      this.newSitesSelected = newValue;
      const countrySelected = this.newCountrySelected[0] === "all" ? this.countryList : this.newCountrySelected;
      const sitesSelected = this.newSitesSelected[0] === "all" ? this.allSiteList : this.newSitesSelected;
      this.newCircleData = se.getDataForCircleMarker(this.rawData, countrySelected, sitesSelected);
      this.downloadDataMaps = se.generateMapParticipantSeries(this.newCircleData);
    }
  },
  methods: {
    onClick: function(value) {
      const index = this.newStatusSelected.indexOf(value);

      if (index > -1) {
        this.newStatusSelected.splice(index, 1);
      } else {
        this.newStatusSelected.push(value);
      }
    },
    onZoomIn: function() {
      if (this.zoomValue >= 0 && this.zoomValue < 19) {
        this.zoomValue += 1;
      }
    },
    onZoomOut: function() {
      if (this.zoomValue > 0 && this.zoomValue <= 19) {
        this.zoomValue -= 1;
      }
    },
    zoomEnabled() {
      this.$emit("zoomEnabled");
    },
    zoomDisabled() {
      this.$emit("zoomDisabled");
    },
    downloadCsvMaps(title) {
      if (_.isEmpty(this.downloadDataMaps)) {
        return;
      }
      let csvHeaders;

      const csvContent = [];
      csvHeaders = ["Site Name", "Country", "City", "Active", "Active with Modifications", "Disqualified", "Withdrawn"];
      if (!this.legacyVal) {
        csvHeaders = ["Site Name", "Country", "City", "Active", "Active with Modifications", "Discontinued"];
      }
      const countrySelected = this.countrySelected == "all" ? this.countryList : this.countrySelected;
      const siteSelected = this.sitesSelected == "all" ? this.allSiteList : this.sitesSelected;

      const rawData = se.getDataForCircleMarker(this.rawData, countrySelected, siteSelected);
      this.downloadDataMaps = se.generateMapParticipantSeries(rawData);

      this.downloadDataMaps.map(item => csvContent.push([item.siteName, item.country, item.city, item.active, item.activewithmodifications, item.disqualified, item.withdrawn]));
      downloadCSV(title, csvHeaders, csvContent, this.specificSiteId);
    },
    async checkLegacyValue() {
      await this.$api.getLegacyData(this.studyId).then(response => {
        if (response) {
          this.legacyVal = response.body;
        }
      });
      if (this.legacyVal == false) {
        this.newStatusSelected = ["ACTIVE", "DISCONTINUED", "ACTIVEWMODIFICATION"];
      }
    }
  },
  mounted() {
    this.checkLegacyValue();
  },
  computed: {
    config() {
      return {
        ...mapSettings,
        zoomControl: false,
        center: { lat: 0, lng: 0 }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.study-participant-status-maps-zoom .card-participant-map {
  height: 450px;
}
.card-participant-map {
  width: calc(100% - 155px);
  height: 250px;
  margin-top: 10px;
}
.map-flex {
  display: flex;
  align-items: center;
}
.card-map-legend {
  .rbac-legend {
    font-size: 12px;
    padding-left: 25px;
  }
  span {
    color: #666669;
  }
  .selected {
    text-decoration: line-through;
    font-style: italic;
    opacity: 0.5;
  }
  ul li {
    list-style-type: none;
    cursor: pointer;
    padding-bottom: 5px;
    display: flex;

    span {
      font-size: 10px;
      line-height: 1;

      span {
        height: 10px;
        width: 10px;
        float: left;
        margin-right: 8px;
      }
    }

    .active-status {
      background-color: var(--study-primary-color);
    }

    .disqualified-status {
      background-color: #fb9a99;
    }

    .invited-status {
      background-color: #7f69d4;
    }

    .notInvited-status {
      background-color: #b269d4;
    }

    .withdrawStudy-status {
      background-color: #fdbf6f;
    }
  }
}
</style>
